import React from 'react';
import './About.css';

class About extends React.Component {
  render() {
    return (
      <section className="about" id="about">
        <div className="about-header"></div>
        <div className="container about-container">
          <h1>Gabinet - Podolog Cieszyn</h1>

          <p>
            W Cieszynie w budynku ubezpieczalni na ul. Bielskiej 37  powstał Gabinet medycznej
            pielęgnacji stóp. Miejsce w którym każdy, kto ma problemy ze stopami lub chciałby 
            im zapobiec, znajdzie coś dla siebie. Zapraszamy wszystkich zainteresowanych zabiegami 
            pielęgnacyjnymi poprawiającymi kondycję stóp w zakresie estetycznym oraz fizycznym.
          </p>

          <p>
            Zapewniamy Ci indywidualne podejście do Twojego problemu. W trakcie  pierwszej wizyty 
            ustalamy plan  pielęgnacji z uwzględnieniem stopnia zaawansowania problemu, uwarunkowań 
            osobniczych takich jak: wiek,  ogólny stan zdrowia, charakter wykonywanej pracy i wielu innych.
          </p>

          <p>
            W gabinecie w najwyższym stopniu przestrzegane są zasady higieny. Realizację 
            tych zasad regulują odpowiednie wdrożone  procedury, przeznaczone do tego celu 
            środki dezynfekcyjne oraz urządzenia takie jak: autoklaw klasy B (najlepsze 
            urządzenie pod względem skuteczności sterylizacji spełniające 
            rygorystyczne normy), myjka ultradźwiękowa oraz lampa bakteriobójcza.
          </p>

          <p>
            Wszystkie narzędzia używane w gabinecie podologicznym za 
            wyjątkiem jednorazowych (podlegających utylizacji) poddawane są 
            procesowi dezynfekcji oraz sterylizacji w odpowiednich opakowaniach 
            sterylizacyjnych stanowiących ochronę produktu sterylnego przed wtórnym 
            zakażeniem po zakończeniu procesu sterylizacji, a przed kolejnym użyciem. 
            Pracujemy na narzędziach, kosmetykach i płynach do dezynfekcji renomowanych niemieckich firm. 
            Osiągamy najwyższy możliwy poziom bezpieczeństwa klienta oraz  personelu.
          </p>

          <h2>Co to jest podologia?</h2>

          <p>
            Podologia, podiatria jest  dziedziną na pograniczu kosmetologii oraz  medycyny zajmującą 
            się diagnozowaniem i leczeniem  chorób stopy i stawu skokowo-goleniowego. Zabiegi podologiczne 
            mają różnoraki charakter i wymagają od osoby praktykującej ten zawód wiedzy z 
            zakresu nauk medycznych głównie : diabetologii, dermatologii, ortopedii, opatrywania ran, 
            technik zaopatrzenia ortopedycznego (ortozy , wkładki ortopedyczne). Podolodzy szczególnie 
            często zajmują się profilaktyką i leczeniem stóp sportowców.  Z zabiegów podologicznych 
            przede wszystkim powinny korzystać osoby ograniczone ruchowo, dotknięte chorobami skóry, kości i stawów, reumatyzmem, chorobami przemiany materii 
            jak np cukrzyca, z wadliwym ustawieniem stóp i deformacjami palców (haluksy, palce krogulcze), z dolegliwościami na stopach t.j.: 
            odciskami, modzelami, brodawkami,  wrastającymi czy grzybiczymi 
            paznokciami a także nadmierną potliwością  stóp i rozpadlinami na piętach.
          </p>
        </div>
      </section>
    );
  }
}

export default About;
